import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { userRegister } from '../../../service/userService';
import MainContext from '../../context/mainContext';
import { userRegisterValidator } from './../../../service/validatorForms';

const LoginPage3 = ({ mobileNumberRef, closeLoginModal }) => {
    const [fullName, setFullName] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const validatorRef = useRef(userRegisterValidator());
	const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const { addToast } = useToasts();
    const context = useContext(MainContext)
	const textInputRef = useRef(null);

	const submitHandler = async (event) => {
		event.preventDefault();
		try {
		    if (validatorRef.current.allValid()) {
				setIsLoading(true);
		        const user = {
		            fullName: fullName,
					mobileNumber: mobileNumberRef.current,
		        }
		        const { status, data } = await userRegister(user);
		        if (status === 201) {
                    localStorage.setItem('token', data.token);
                    context.login(data.user);
                    addToast('ثبت نام با موفقیت انجام شد', {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    closeLoginModal();
		        }
		    }
		    else {
		        validatorRef.current.showMessages();
		        forceUpdate();
		    }

		} catch (err) {
		    if (err.response && err.response.status === 422){
                addToast("اطلاعات را به طور صحیح وارد کنید", {
                    appearance: 'error',
                    autoDismiss: true,
                })
				setIsLoading(false);
			}
            //بلاک شده
		    // else if (err.response && err.response.status === 404) {
			// 	errorMessage('این شماره موبایل قبلا ثبت شده است');
			// 	setIsLoading(false);
		    //     validatorRef.current.hideMessageFor('fullName');
		    //     validatorRef.current.hideMessageFor('password');
		    //     forceUpdate();
		    // }
		}
	}

	useEffect(() => {
		textInputRef.current.focus();
	},[]);

    return ( 
		<React.Fragment>
			<form onSubmit={submitHandler} className=" px-3">
				<p className="text-center">
					<span className="text-success" style={{fontSize:'1.2rem'}}>
						<i className="fa fa-check-circle-o text-success" 
							style={{fontSize:'1.6rem', position:'relative', top:'5px', left:'10px'}}>
						</i>
						{mobileNumberRef.current}</span>
				</p>
				<div className=" mb-3">
					<label htmlFor="fullName" className="text-light">
						اسم و فامیل
					</label>
					<input
						autoComplete="off"
						type="text"
						className="form-control"
						id="fullName"
						name="fullName"
						placeholder="اسم و فامیل خودتو وارد کن"
						value={fullName}
						onChange={(e) => setFullName(e.target.value)}
						onBlur={() => {
							if (fullName !== '') {
								validatorRef.current.showMessageFor("fullName");
								forceUpdate();
							}
						}}
						ref={textInputRef}
					/>
					{validatorRef.current.message(
						"fullName",
						fullName,
						"required|max:25"
					)}
				</div>

				<section className="card-body pt-1">
					<div className="text-center ">
						<button
							type="submit"
							className="btn btn-success px-2 py-1"
							onClick={submitHandler}
							disabled={isLoading}
							>
							{
								isLoading &&
								<i className='spinner-border spinner-border-sm operator-button mr-2'
									style={{ position: 'relative', bottom: '4px' }}
								></i>
							}
							تأیید
					</button>
					</div>
				</section>
			</form>
		</React.Fragment>
     );
}
 
export default LoginPage3;